// extracted by mini-css-extract-plugin
export default {"prize-rules":"Uydti41LQPkoCn0UivvR","intro":"UN1EpqAUgS4PtXFttNFw","sections":"oGRygsbQahQt1DoVWkMw","content":"vjypF8bjljQX6WoCq78p","title":"BWfT8_dcE0AhcTyMg3Yi"};